import { Avatar, Box, Button, Flex, HStack, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from '@chakra-ui/react';
import { ChangeEvent, useEffect, useState } from 'react';
import { RiSearch2Line } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import AdminDashboardHeader from '../../../components/admin/AdminHeader';
import AdminSidebar from '../../../components/admin/AdminSidebar';
import Loading from '../../../components/common/Loading';
import AdminHelpers from '../../../services/admin/admin.service';
import userService from '../../../services/user.service';

const Posting = () => {
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const [postings, setPostings] = useState([]);
    const [isOpenApproveModal, setIsOpenApproveModal] = useState(false);
    const [filteredPostings, setFilteredPostings] = useState<any>([]);
    const [isSearchEmpty, setIsSearchEmpty] = useState(false);
    const [selectedCenter, setSelectedCenter] = useState('');
    const [programModuleId, setProgramModuleId] = useState<number>(0);
    const [admissionCode, setAdmissionCode] = useState('');
    const [centers, setCenters] = useState<any>([]);
    const [reload, setReload] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {

        const fetchData = async () => {
            try {
                const postingResponse = await AdminHelpers.getPostings();

                const postingsData = postingResponse.data;
                
                const updatedPostings: any = [];
                for (const post of postingsData) {
                    const traineeId = post.trainee_id;
                    const userProfileResponse = await userService.getUserProfile(traineeId);
                    const userProfile = userProfileResponse.data;
                    const updatedPosting = {
                        ...post,
                        userProfile: userProfile // Add user profile data to the posting object
                    };
                    updatedPostings.push(updatedPosting);
                }
                setPostings(updatedPostings);
                setFilteredPostings(updatedPostings);
            } catch (err) {
                console.error("Error fetching data:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

        AdminHelpers.getAllCenters().then(
            (res) => {
                
                setCenters(res.data.data);
            }
        )
    }, [reload])

    const filterCenter = (id: number) => {
        const matchingCenters = centers.filter((center: any) => center.id === id);
        return matchingCenters.map((center: any) => center.name);
    };

    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        const searchTerm = event.target.value.toLowerCase();
        if (!searchTerm) {
            setFilteredPostings(postings);
        } else {
            if (postings) {
                const filtered = postings.filter((each: any) =>
                    each.userProfile.name.toLowerCase().includes(searchTerm)
                );
                setFilteredPostings(filtered);
                if (filtered && filtered.length > 0) setIsSearchEmpty(false);
                else setIsSearchEmpty(true);
            }
        }
    };

    const openApprovePostingModal = (programModuleId: number, admission_code: string) => {
        setIsOpenApproveModal(true);
        setProgramModuleId(programModuleId);
        setAdmissionCode(admission_code)
    }

    const closeApprovePostingModal = () => {
        setIsOpenApproveModal(false);
    };

    const handleEditPosting = async () => {
        const updatePostingData = {
            program_module_id: programModuleId,
            postings: [
                {
                    admission_code: admissionCode.toString(),
                    final_centre: selectedCenter.toString(),
                }
            ]
        }
        try {
            const adjustPostingResponse = await AdminHelpers.approvePosting(updatePostingData);
            toast({
                title: "Approve posting",
                description: 'Posting adjusted successfully',
                status: "success",
                duration: 3000,
            });
            setReload(!reload)
        } catch (error) {
            console.error("Error adjusting posting:", error);
            toast({
                title: "Approve posting",
                description: 'Something went wrong',
                status: "error",
                duration: 3000,
            });
        } finally {
            setIsOpenApproveModal(false);
            setSelectedCenter("");
        }
    };

    return (
        <>
            {
                loading ? <Loading /> :
                    <Flex             minHeight={"100vh"}
                    height={"auto"}
                    boxSizing="border-box"
                    maxWidth={"100hw"}>
                       <Box
              width={["4rem", "4rem", "4rem", "20%"]}
              position="relative"
              top="0"
              left="0"
              zIndex="100"
            >
              <AdminSidebar />
            </Box>
                        <Box width='100%' >
                            <AdminDashboardHeader />
                            <Box           pt="30px"
                px={["20px", "30px"]}
                width={"100%"}
                bg="#F9F8F8"
                height={"auto"}
                minHeight={"95vh"}
                maxHeight={"95vh"}
                overflowX={"scroll"}
                className="scroll-hidden">
                                <Flex
                                    justifyContent="space-between"
                                    alignItems="center"
                                    py="26px"
                                >
                                    <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                                        Manage Postings
                                    </Box>

                                </Flex>
                                <Flex py='15px' justifyContent=''>
                                    <InputGroup color="brand.subtitle" bg="white"         width={["100%", "100%", "50%", "30%"]}mr='20px'>
                                        <Input height='40px' placeholder="Search posting by trainee name" fontSize={12} size="sm" onChange={(e) => handleSearchChange(e)} />
                                        <InputRightElement pointerEvents="none" children={<RiSearch2Line color="red" size="0.9rem" />} />
                                    </InputGroup>

                                </Flex>
                                <Box width={'100%'}>
                                    <TableContainer>
                                        <Table>
                                            <Thead>
                                                <Tr>
                                                    <Th>Name</Th>
                                                    <Th>Email</Th>
                                                    <Th>Admission Code</Th>
                                                    <Th>Center 1</Th>
                                                    <Th>Center 2</Th>
                                                    <Th>Final Centre</Th>
                                                    <Th>Edit</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {
                                                    filteredPostings?.map((each: any, i: number) => {
                                                        return (
                                                            <Tr bg="white" borderWidth="1px" key={i}>
                                                                <Td>
                                                                    <HStack>
                                                                        <Avatar
                                                                            name={each?.userProfile.name}
                                                                            src='https://bit.ly/broken-link'
                                                                        />
                                                                        <Text>{each?.userProfile.name}</Text>
                                                                    </HStack>
                                                                </Td>
                                                                <Td>{each?.userProfile.email}</Td>
                                                                <Td>{each?.admission_code}</Td>
                                                                <Td>{filterCenter(each?.centre_one)}</Td>
                                                                <Td>{filterCenter(each?.centre_two)}</Td>
                                                                {
                                                                    each.centre_final !== null ?
                                                                        <Td>{filterCenter(each?.centre_final)}</Td> :
                                                                        <Td>Yet to approve</Td>
                                                                }
                                                                <Td>
                                                                    <Button onClick={() => openApprovePostingModal(each.program_module_id, each.admission_code)}>Edit</Button>
                                                                </Td>
                                                            </Tr>
                                                        )
                                                    })
                                                }
                                            </Tbody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Box>
                        </Box>
                    </Flex>

            }
            {
                centers && (
                    <Modal isOpen={isOpenApproveModal} onClose={closeApprovePostingModal}>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader fontSize={'22px'}>Adjust Trainee Posting</ModalHeader>
                            <ModalCloseButton />
                            <form onSubmit={handleEditPosting}>

                                <ModalBody>
                                    <Text>Select Center:</Text>
                                    <Select value={selectedCenter} placeholder="Select trainee final centre" onChange={(e) => setSelectedCenter(e.target.value)}>
                                        {
                                            centers?.map((center: any, index: number) => {
                                                return (
                                                    <option key={index} value={center.id}>{center.name}</option>
                                                )
                                            })
                                        }
                                    </Select>
                                </ModalBody>

                                <ModalFooter>
                                    <Button onClick={() => handleEditPosting()} colorScheme='red'>Approve/Adjust</Button>
                                </ModalFooter>
                            </form>
                        </ModalContent>
                    </Modal>
                )
            }

        </>
    )
}

export default Posting